import queryString from 'query-string';
import sharedHistory from '../shared_history';
import { useEffect, useState } from 'react';

/**
 * Helper for getting and setting query parameters from the browser location object.
 *
 * Returns a 2 element array containing the parsed query parameters and a setter to update them. The parameters
 * passed to the setter are merged with the existing parameters. If a key is set to null or undefined, it's removed.
 *
 * @example
 * const [params, setParams] = useParams(location);
 *
 * // access parameter "foo"
 * params.foo
 *
 * // set parameter "foo"
 * setParams({foo: "bar"})
 *
 * @param location location object
 * @param history browser history object, optional
 * @returns {[ParsedQuery<string>,((value: (((prevState: {}) => {}) | {})) => void)]}
 */
const useParams = (location, history = sharedHistory) => {
  const params = queryString.parse(location.search);
  const [newParams, setNewParams] = useState(null);

  useEffect(() => {
    if (newParams === null) {
      return;
    }

    const newSearch = {...params, ...newParams};

    Object.keys(newParams).forEach(key => {
      if (newParams[key] === null || newParams[key] === undefined) {
        delete newSearch[key];
      }
    });

    history.push({ ...location, search: '?' + queryString.stringify(newSearch) });
  }, [newParams]);

  return [params, setNewParams];
};

export default useParams;
